import React from 'react';

import Clock from './clock.jsx';
import Counter from './counter.jsx';
import Range from './range.jsx';

export default function App(props) {
  const [period, setPeriod] = React.useState(1/FREQS.min);
  const [count, setCount] = React.useState(0);

  const freqChange = freq => setPeriod(1/freq);
  const tick = () => setCount(c => c + 1);
  return [
    <Counter label="Count" value={count} key="count"/>,
    <Range label="Frequency" {...FREQS} unit="Hz." onChange={freqChange}
           key="range"/>,
    <Clock label="Clock" period={period} tick={tick} key="clock"/>
  ];
}

const FREQS = { min: 0.5, max: 5, step: 0.1 };

/*
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      period: 1/FREQS.min,
      count: 0
    };
    this.freqChange = this.freqChange.bind(this);
    this.tick = this.tick.bind(this);
  }

  tick() {
    this.setState({count: this.state.count + 1});
  }

  freqChange(freq) {
    this.setState({period: 1/freq});
  }

  render() {
    const {period, count} = this.state;
    return [
      <Counter label="Count" value={count} key="count"/>,
      <Range label="Frequency" {...FREQS} unit="Hz." onChange={this.freqChange}
             key="range"/>,
      <Clock label="Clock" period={period} tick={this.tick} key="clock"/>
    ];
  }
}

export default App;
*/
